import { render, staticRenderFns } from "./EmployeePreviewCard.vue?vue&type=template&id=0c4e1f5a"
import script from "./EmployeePreviewCard.vue?vue&type=script&lang=js"
export * from "./EmployeePreviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports